import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// PAGES
import {
  Register,
  Login,
  Dashboard,
  Profile,
  Home,
  MyClasses,
  ClassHistory,
  OnlineClasses,
  AddStaff,
  Tutor,
  AddStudent,
  OrganizeEvent,
  OrganizeTrip,
  Chat,
  RatingPage,
  MyPromotions,
  Notifications,
  MyWallet,
  Dispute,
  TransactionHistory,
  PurchasesHistory,
  PurchasesProduct,
  HomeMain,
  MostPopularCourses,
  MostPopularCoursesDetails,
  MostPopularTutors,
  MostPopularTutorsDetails,
  UpcommingEvents,
  UpcommingEventsDetails,
  OurLatestUpdate,
  OurLatestUpdateDetails,
  Banner,
  AddMostPopulerTutors,
  AboutUs,
  AddPopulerCourses,
  Setting,
  AddOurStudentSays,
  AddUpcommingEvents,
  AddOurLatestUpdate,
  Invoice,
  TimeTable,
  LeaveRequest,
  Assignment,
  SubmitedTask,
  Result,
  AddClass,
  MyClassesView,
  HistoryView,
  ClassHistoryAnalytics,
  OnlineClassAnalytics,
  OnlineClassView,
  OnlineClassCreate,
  AddStaffAnalytics,
  AddStaffAdd,
  TutorAnalytics,
  TutorAdd,
  AddStudentAnalytics,
  AddStudentAdd,
  OrganizeEventAnalytics,
  OrganizeEventView,
  OrganizeEventCreate,
  OrganizeTripAnalytics,
  OrganizeTripView,
  OrganizeTripCreate,
  OrganizeTripBook,
  RatingView,
  RatingAnalytics,
  MyPromotionCreate,
  NotificationView,
  CreateNewInvoice,
  InvoiceView,
  InvoicePreview,
  InvoiceSetting,
  ViewResult,
  ViewSubmitedTask,
  ViewAssignment,
  ViewLeaveRequest,
  PurchasesProductView,
  PurchasesProductMyCart,
  PurchasesProductMessage,
  Attendance,
  Tc,
  DisputeView,
  SalaryRequests,
  TransactionHistoryView,
  PurchasesHistoryView,
} from "./../../pages";
let RouterNavigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeMain />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/dasboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/my-classes" element={<MyClasses />} />
        <Route path="/my-classes/create" element={<AddClass />} />
        <Route path="/my-classes/view" element={<MyClassesView />} />
        <Route path="/class-history" element={<ClassHistory />} />
        <Route path="/class-history/view" element={<HistoryView />} />
        <Route
          path="/class-history/analytics"
          element={<ClassHistoryAnalytics />}
        />
        <Route path="/online-classes" element={<OnlineClasses />} />
        <Route
          path="/online-class/analytics"
          element={<OnlineClassAnalytics />}
        />
        <Route path="/online-class/view" element={<OnlineClassView />} />
        <Route path="/online-class/create" element={<OnlineClassCreate />} />
        <Route path="/add-staff" element={<AddStaff />} />
        <Route path="/add-staff/analytics" element={<AddStaffAnalytics />} />
        <Route path="/add-staff/add" element={<AddStaffAdd />} />
        <Route path="/tutor" element={<Tutor />} />
        <Route path="/tutor/analytics" element={<TutorAnalytics />} />
        <Route path="/tutor/add" element={<TutorAdd />} />
        <Route path="/add-student" element={<AddStudent />} />
        <Route
          path="/add-student/analytics"
          element={<AddStudentAnalytics />}
        />
        <Route path="/add-student/add" element={<AddStudentAdd />} />
        <Route path="/organize-event" element={<OrganizeEvent />} />
        <Route
          path="/organize-event/analytics"
          element={<OrganizeEventAnalytics />}
        />
        <Route path="/organize-event/view" element={<OrganizeEventView />} />
        <Route
          path="/organize-event/create"
          element={<OrganizeEventCreate />}
        />
        <Route path="/organize-trip" element={<OrganizeTrip />} />
        <Route
          path="/organize-trip/analytics"
          element={<OrganizeTripAnalytics />}
        />
        <Route path="/organize-trip/view" element={<OrganizeTripView />} />
        <Route path="/organize-trip/create" element={<OrganizeTripCreate />} />
        <Route path="/organize-trip/book" element={<OrganizeTripBook />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/rating" element={<RatingPage />} />
        <Route path="/rating/view" element={<RatingView />} />
        <Route path="/rating/analytics" element={<RatingAnalytics />} />
        <Route path="/my-promotions" element={<MyPromotions />} />
        <Route path="/my-promotions/create" element={<MyPromotionCreate />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/notification/view" element={<NotificationView />} />
        <Route path="/my-wallet" element={<MyWallet />} />
        <Route path="/dispute" element={<Dispute />} />
        <Route path="/dispute/view" element={<DisputeView />} />
        <Route path="/transaction-history" element={<TransactionHistory />} />
        <Route
          path="/transaction-history/view"
          element={<TransactionHistoryView />}
        />
        <Route path="/purchases-history" element={<PurchasesHistory />} />
        <Route
          path="/purchases-history/view"
          element={<PurchasesHistoryView />}
        />
        <Route path="/purchases-product" element={<PurchasesProduct />} />
        <Route
          path="/purchases-product/view"
          element={<PurchasesProductView />}
        />
        <Route
          path="/purchases-product/my-cart"
          element={<PurchasesProductMyCart />}
        />
        <Route
          path="/purchases-product/message"
          element={<PurchasesProductMessage />}
        />
        <Route path="/most-popular-courses" element={<MostPopularCourses />} />
        <Route
          path="/most-popular-courses/details"
          element={<MostPopularCoursesDetails />}
        />
        <Route path="/most-popular-tutors" element={<MostPopularTutors />} />
        <Route
          path="/most-popular-tutors/details"
          element={<MostPopularTutorsDetails />}
        />
        <Route path="/upcomming-events" element={<UpcommingEvents />} />
        <Route
          path="/upcomming-events/details"
          element={<UpcommingEventsDetails />}
        />
        <Route path="/our-latest-update" element={<OurLatestUpdate />} />
        <Route
          path="/our-latest-update/details"
          element={<OurLatestUpdateDetails />}
        />
        <Route path="/banner" element={<Banner />} />
        <Route
          path="/add-most-populer-tutors"
          element={<AddMostPopulerTutors />}
        />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/add-populer-courses" element={<AddPopulerCourses />} />
        <Route path="/settings" element={<Setting />} />
        <Route path="/settings/invoice" element={<InvoiceSetting />} />
        <Route path="/settings/tc" element={<Tc />} />
        <Route path="/add-our-student-says" element={<AddOurStudentSays />} />
        <Route path="/add-upcomming-events" element={<AddUpcommingEvents />} />
        <Route path="/add-our-latest-update" element={<AddOurLatestUpdate />} />
        <Route path="/invoice" element={<Invoice />} />
        <Route path="/invoice/create" element={<CreateNewInvoice />} />
        <Route path="/invoice/view" element={<InvoiceView />} />
        <Route path="/invoice/preview" element={<InvoicePreview />} />
        <Route path="/time-table" element={<TimeTable />} />
        <Route path="/leave-request" element={<LeaveRequest />} />
        <Route path="/leave-request/view" element={<ViewLeaveRequest />} />
        <Route path="/assignment" element={<Assignment />} />
        <Route path="/assignment/view" element={<ViewAssignment />} />
        <Route path="/submited-task" element={<SubmitedTask />} />
        <Route path="/submited-task/view" element={<ViewSubmitedTask />} />
        <Route path="/result" element={<Result />} />
        <Route path="/result/view" element={<ViewResult />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/salary-requests" element={<SalaryRequests />} />
      </Routes>
    </BrowserRouter>
  );
};
export default RouterNavigation;
